import { BackendSection, Section } from '../types/entities'

const mapBackendSections = (backendSections: BackendSection[]): Section[] => (
  backendSections.map(({
    id,
    name,
    category_id: categoryId,
    html_url: htmlURL,
    icon_name: iconName,
    description,
  }) => ({
    id,
    name,
    categoryId,
    htmlURL,
    iconName,
    description,
  }))
)

export { mapBackendSections }
